const mfo = {

	elem: {
		component: document.querySelector('.mfo'),
		images: document.querySelectorAll('.mfo__image'),
		links: document.querySelectorAll('.mfo .br-tabs__link')
	},

	// This is a normal set of tabs but we need an additional behavior: when the tab is selected we need to update which farmer-owner profile image is being displayed behind the tab controls
	init() {
		if(mfo.elem.component) {
			mfo.elem.component.tab = Object.assign(new BRTabs(mfo.elem.component))

			let active = mfo.elem.component.querySelector('.br-tabs__link[aria-selected=true]');

			mfo.elem.component.querySelector('.mfo__image[data-tab=' + active.id + ']').classList.add('mfo__image--active');
			
			mfo.elem.component.addEventListener('openTab', function() {
				let active = '';
				
				mfo.elem.links.forEach(function(element) {
					if(element.ariaSelected === 'true') {
						active = element.id;
					};
				});
				
				mfo.elem.images.forEach(function(element) {
					element.classList.remove('mfo__image--active');

					if((active !== '') && (element.dataset.tab === active)) {
						element.classList.add('mfo__image--active');
					}
				});
			});
			
		}
	}
};

export { mfo };
